import { useToast } from '@chillibean/component-library';
import { useDispatch, useSelector } from 'react-redux';

import { RouteLeavingGuard, ProtocolForm } from '../../components/container';
import { updateProtocol } from '../../redux/actions';

export function ProtocolsEditPage() {
  // HOOKS
  // Store
  const dispatch = useDispatch();
  const { data: protocol, loading } = useSelector((state) => state.protocolReducer.protocol);
  const { data: protocolUpdated } = useSelector((state) => state.protocolReducer.protocolUpdated);
  // Custom
  const { showErrorToast, showSuccessToast } = useToast();

  const handleUpdateProtocol = (data) => {
    dispatch(
      updateProtocol({
        identifier: protocol.id,
        onError: showErrorToast,
        onSuccess: () => showSuccessToast('Trial Configuration saved successfully'),
        protocolData: data,
      }),
    );
  };

  return (
    <>
      <RouteLeavingGuard
        headerText="You have unsaved changes"
        navigationBlocked={protocolUpdated}
        warningText="You are about to discard all the data you have entered. This action is irreversible."
      />
      <ProtocolForm loading={loading} locked={protocol?.locked} onSave={handleUpdateProtocol} protocol={protocol} />
    </>
  );
}

export default ProtocolsEditPage;
